import React from "react";

const H3: React.FC<{ text: string; color?: string }> = ({
  text,
  color = "text-primary",
}) => {
  return (
    <h2 className={`text-lg tracking-tight ${color} sm:text-xl text-balance`}>
      {text}
    </h2>
  );
};

export default H3;
